/**
 * /app/analysis/beams — lista de análisis de vigas guardados.
 *
 * Usa el mismo componente DesignsList que los módulos de diseño, pero con
 * `module="analysis_beams"` para filtrar solo análisis (no diseños).
 */

import { Square } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function BeamsAnalysisIndexPage() {
  return (
    <DesignsList
      module="analysis_beams"
      description="Análisis estructural de vigas — abre uno guardado o crea uno nuevo."
      icon={<Square size={24} strokeWidth={1.5} />}
    />
  );
}
